/**
 * ifg-chaos
 */

import { styleAtom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const StylizeComp = createSliderInputComponent(
  {
    label: '风格参数',
    atom: styleAtom,
    helpContent: '风格参数（Stylize）的值越高，越偏离你的描述，艺术性更强',
    min: 0,
    max: 100,
    step: 1,
    digits: 0,
  },
  'StylizeComp'
)

export { StylizeComp }
